import type { FunctionComponent, Dispatch, SetStateAction } from 'react';
import React from 'react';

import { Col, Row } from 'src/components/ui';
import Form from 'src/components/ui/Form';
import InputGroup from 'src/components/ui/InputGroup';

import type { UpdateFieldType } from '../contactForm/ContactForm';
import style from '../contactForm/ContactForm.module.scss';

import type { ContactFormData } from 'src/models/contact';

import { mergeClassNames } from 'src/utils/ReactUtils';

type RequestCommercialNetworkFormType = {
  updateField: UpdateFieldType;
  formValue: ContactFormData;
  setFormValue: Dispatch<SetStateAction<ContactFormData>>;
};

const RequestCommercialNetworkForm: FunctionComponent<
  RequestCommercialNetworkFormType
> = ({ updateField, formValue, setFormValue }) => {
  const updateCommercialActivity = (value: string) => {
    let commercialActivities = formValue.commericalActivity?.split(',') ?? [];
    if (commercialActivities.includes(value)) {
      commercialActivities = commercialActivities.filter(
        (item) => item !== value,
      );
    } else {
      commercialActivities.push(value);
    }
    setFormValue({
      ...formValue,
      commericalActivity: commercialActivities.join(','),
    });
  };
  return (
    <>
      <Row>
        <Col md={12}>
          <Form.Label className={style.contactFormLabel}>
            Nous avons besoin d’information complémentaire *:
          </Form.Label>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Form.Group controlId="commericalActivity">
            <Form.Label
              className={mergeClassNames([
                style.contactFormLabel,
                style.contactFormLabelRequired,
              ])}
            >
              Activité
            </Form.Label>
            <Form.Check
              inline
              label="Garage"
              value="1"
              checked={formValue.commericalActivity?.includes('1')}
              name="commericalActivity"
              type="checkbox"
              id="commericalActivity-1"
              required={!formValue.commericalActivity?.length}
              onChange={(e) => updateCommercialActivity(e.target.value)}
            />
            <Form.Check
              inline
              label="Carosserie"
              value="2"
              checked={formValue.commericalActivity?.includes('2')}
              name="commericalActivity"
              type="checkbox"
              id="commericalActivity-2"
              required={!formValue.commericalActivity?.length}
              onChange={(e) => updateCommercialActivity(e.target.value)}
            />
            <Form.Control.Feedback type="invalid">
              Ce champ est obligatoire.
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group controlId="commericalSituation">
            <Form.Label
              className={mergeClassNames([
                style.contactFormLabel,
                style.contactFormLabelRequired,
              ])}
            >
              Situation
            </Form.Label>
            <Form.Check
              inline
              label="Création"
              value="1"
              checked={formValue.commericalSituation === 1}
              name="commericalSituation"
              id="commericalSituation1"
              type="radio"
              onChange={(e) => updateField(e, Number(e.target.value))}
              required
            />
            <Form.Check
              inline
              label="Existant"
              value="2"
              checked={formValue.commericalSituation === 2}
              name="commericalSituation"
              id="commericalSituation2"
              type="radio"
              onChange={(e) => updateField(e, Number(e.target.value))}
              required
            />
            <Form.Control.Feedback type="invalid">
              Ce champ est obligatoire.
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        {formValue.commericalSituation === 2 && (
          <Col md={6}>
            <Form.Group controlId="commercialNetwork">
              <Form.Label className={style.contactFormLabel}>
                {"Votre réseau d'appartenance"}
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Votre réseau d'appartenance"
                onChange={updateField}
                value={formValue.commercialNetwork}
                name="commercialNetwork"
              />
            </Form.Group>
          </Col>
        )}
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group controlId="commercialCP">
            <Form.Label
              className={mergeClassNames([
                style.contactFormLabel,
                style.contactFormLabelRequired,
              ])}
            >
              Code postal
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Code postal *"
              required
              pattern={'^[0-9]{0,5}$'}
              onChange={updateField}
              value={formValue.commercialCP}
              name="commercialCP"
            />
            <Form.Control.Feedback type="invalid">
              {!formValue?.commercialCP?.length
                ? 'Ce champ est obligatoire.'
                : 'Le format est invalide'}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId="productiveNumber">
            <Form.Label className={style.contactFormLabel}>
              Nombre de productifs
            </Form.Label>
            <InputGroup hasValidation>
              <Form.Control
                type="text"
                placeholder="Nombre de productifs"
                pattern={'^[0-9]*$'}
                onChange={updateField}
                value={formValue.productiveNumber}
                name="productiveNumber"
              />
              <Form.Control.Feedback type="invalid">
                {'Le format est invalide'}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default RequestCommercialNetworkForm;
